{
	"title": "Διαχείριση δηλώσεων",
	"createDeclaration": "Δημιουργία δήλωσης"
}
